import { Model } from './model';

export class Entity extends Model {
  id: number;
  name: string;
  type: string;

  constructor(values: Object = {}) {
    super(values);
  }

  public apiMap(values: Object = {}) {
    return new Entity(values);
  }
}



// WEBPACK FOOTER //
// ./src/app/_models/entity.ts